import { useState } from "react";
import { MapPin, Phone, Mail, MessageCircle, Loader2, Check } from "lucide-react";
import api from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { PageHero } from "@/components/Bits";

export default function Contato() {
  const { config } = useSite();
  const [form, setForm] = useState({ name: "", company: "", phone: "", email: "", city: "", message: "" });
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) { toast.error("Informe nome e telefone."); return; }
    setSaving(true);
    try {
      await api.post("/leads", { ...form, source: "contato", equipment_type: "Contato geral" });
      setDone(true);
      toast.success("Mensagem enviada!");
    } catch { toast.error("Erro ao enviar. Tente novamente."); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <PageHero eyebrow="Contato" title="Fale com a Global Refrigeração"
        subtitle="Atendemos toda a demanda nacional a partir de Santa Catarina. Envie sua mensagem ou fale por WhatsApp." />
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-12 px-4 py-16 lg:grid-cols-2 lg:px-8">
        <div>
          <div className="space-y-5">
            <div className="flex items-start gap-3"><MapPin className="mt-1 h-5 w-5 text-[#FF5500]" /><div><div className="label-eyebrow">Endereço</div><p className="text-white">{config?.address}</p></div></div>
            <div className="flex items-start gap-3"><Phone className="mt-1 h-5 w-5 text-[#FF5500]" /><div><div className="label-eyebrow">Telefone</div><p className="text-white">{config?.phone}</p></div></div>
            <div className="flex items-start gap-3"><Mail className="mt-1 h-5 w-5 text-[#FF5500]" /><div><div className="label-eyebrow">E-mail</div><p className="text-white">{config?.email}</p></div></div>
          </div>
          <a href={`https://wa.me/${config?.whatsapp || "5547999999999"}`} target="_blank" rel="noopener noreferrer" className="mt-8 inline-flex">
            <Button data-testid="contact-whatsapp-button" className="rounded-none bg-[#25D366] px-6 py-5 font-bold hover:bg-[#1eb85a]"><MessageCircle className="mr-2 h-5 w-5" /> Falar no WhatsApp</Button>
          </a>
        </div>

        <div className="border border-[#27272A] bg-[#151618] p-8">
          {done ? (
            <div className="py-10 text-center" data-testid="contact-success">
              <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center bg-[#FF5500]"><Check className="h-8 w-8 text-white" /></div>
              <p className="text-[#A1A1AA]">Recebemos sua mensagem. Retornaremos em breve.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div className="grid grid-cols-2 gap-3">
                <div><Label className="label-eyebrow">Nome *</Label><Input data-testid="contact-name" value={form.name} onChange={(e) => set("name", e.target.value)} className="mt-1 rounded-none border-[#27272A] bg-[#0A0A0B]" /></div>
                <div><Label className="label-eyebrow">Empresa</Label><Input data-testid="contact-company" value={form.company} onChange={(e) => set("company", e.target.value)} className="mt-1 rounded-none border-[#27272A] bg-[#0A0A0B]" /></div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div><Label className="label-eyebrow">Telefone *</Label><Input data-testid="contact-phone" value={form.phone} onChange={(e) => set("phone", e.target.value)} className="mt-1 rounded-none border-[#27272A] bg-[#0A0A0B]" /></div>
                <div><Label className="label-eyebrow">E-mail</Label><Input data-testid="contact-email" value={form.email} onChange={(e) => set("email", e.target.value)} className="mt-1 rounded-none border-[#27272A] bg-[#0A0A0B]" /></div>
              </div>
              <div><Label className="label-eyebrow">Cidade / UF</Label><Input data-testid="contact-city" value={form.city} onChange={(e) => set("city", e.target.value)} className="mt-1 rounded-none border-[#27272A] bg-[#0A0A0B]" /></div>
              <div><Label className="label-eyebrow">Mensagem</Label><Textarea data-testid="contact-message" value={form.message} onChange={(e) => set("message", e.target.value)} className="mt-1 rounded-none border-[#27272A] bg-[#0A0A0B]" /></div>
              <Button type="submit" data-testid="contact-submit-button" disabled={saving} className="w-full rounded-none bg-[#FF5500] py-5 font-bold hover:bg-[#CC4400]">
                {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Enviar mensagem
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
